import Loadable from "@loadable/component";

const CatalogPage = Loadable(
  () => import(/* webpackChunkName: "catalog_page" */ "./catalogPage")
);

export default CatalogPage;
